module.exports = __webpack_public_path__ + "img/Pic_Support-2_d.609a7099.jpg";